import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import {
  useAuthStatus,
  useStopImpersonation,
  impersonateKeys,
} from "@agentic_system/api/impersonate";
import { sessionKeys } from "@auth/frontend";
import { User, X } from "lucide-react";

export function ImpersonationBadge() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: status } = useAuthStatus();
  const stopImpersonation = useStopImpersonation();

  if (!status?.impersonated) {
    return null;
  }

  const handleStop = async () => {
    await stopImpersonation.mutateAsync();

    // Invalidate caches
    await queryClient.invalidateQueries({ queryKey: sessionKeys.current });
    await queryClient.invalidateQueries({ queryKey: impersonateKeys.status });

    // Navigate back to base (will show profile selector)
    navigate("/system/agentic");
  };

  return (
    <button
      onClick={handleStop}
      disabled={stopImpersonation.isPending}
      className="flex items-center gap-2 px-3 py-1.5 bg-default-50 hover:bg-default-100 text-default-600 border border-default-200 rounded-full text-sm transition-colors"
    >
      <User className="w-4 h-4" />
      <div className="text-left">
        <div className="font-medium leading-tight">{status.impersonated_profile_name}</div>
        <div className="text-xs text-default-400 leading-tight">{status.impersonated_user_name}</div>
      </div>
      <X className="w-4 h-4 opacity-60" />
    </button>
  );
}
